var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg059LogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432,0H80C35.888,0,0,35.888,0,80v20c0,11.046,8.954,20,20,20s20-8.954,20-20V80c0-22.056,17.944-40,40-40h352 c22.056,0,40,17.944,40,40v352c0,22.056-17.944,40-40,40H80c-22.056,0-40-17.944-40-40v-20c0-11.046-8.954-20-20-20 s-20,8.954-20,20v20c0,44.112,35.888,80,80,80h352c44.112,0,80-35.888,80-80V80C512,35.888,476.112,0,432,0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.991,270.278c-0.044-0.046-0.089-0.091-0.134-0.136c-7.798-7.798-7.798-20.486,0.041-28.325l74.284-74.716 c7.788-7.833,7.751-20.496-0.082-28.284c-7.833-7.787-20.496-7.751-28.284,0.082l-74.243,74.675 c-23.369,23.369-23.394,61.379-0.073,84.779l74.224,75.653c3.916,3.993,9.094,5.994,14.277,5.994 c5.054,0,10.113-1.904,14.004-5.723c7.885-7.736,8.006-20.399,0.27-28.283L45.991,270.278z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,236H120c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20h213c11.046,0,20-8.954,20-20S344.046,236,333,236z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg059LogOut);
export default __webpack_public_path__ + "static/media/059-log-out.a5708883f43e347bc1225cb82e34030f.svg";
export { ForwardRef as ReactComponent };